import { type Extension } from '@atlassian/forge-ui';

import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { ssrPrepareErrorsClient } from '@confluence/ssr-utilities/entry-points/SSRPrepareErrorsClient.ts';

import { type UseExtensionListProps } from './useExtensionList.tsx';
// eslint-disable-next-line import/no-cycle
import { preloadForgeApps } from './preloadForgeApps.ts';

const setWindowExtensions = (
	moduleType: string,
	extensions: Extension[],
	error: Error | undefined,
) => {
	window.__SSR_FORGE_EXTENSIONS__ = window.__SSR_FORGE_EXTENSIONS__ || {};
	window.__SSR_FORGE_EXTENSIONS__[moduleType] = {
		extensions,
		error,
	};
};

export async function preloadUseExtensionList({
	contentId,
	spaceKey,
	moduleType,
}: UseExtensionListProps & {
	contentId?: string;
	spaceKey: string;
	skipFilter?: boolean;
}) {
	const { cloudId, locale } = getPreloaderFnContext();

	return SSRMeasures.run('ssr-app/prepare/preloadQuery/fetch:ForgeExtensionList', async () => {
		try {
			const extensions = await preloadForgeApps({
				cloudId,
				locale,
				types: [moduleType],
				context: {
					spaceKey,
					contentId,
				},
				includeHidden: false,
			});

			if (extensions) {
				setWindowExtensions(moduleType, extensions, undefined);
			}
		} catch (e) {
			ssrPrepareErrorsClient.submitError(
				new Error(`Filed to get forge extension list: ${e.message}`),
			);
		}
	});
}
